import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { isMobileOnly } from 'react-device-detect';
import { Layout, message } from 'antd';
import { setSizeChangerList, setInitialData, setLoading, setError, setParams, setCreativeViewSize } from 'context/actions';
import { useAppState, useAppDispatch, ShareUrlParamsType } from 'context';
import { useRequest, UseRequestType } from 'hooks';
import { readParams, getParamsObj } from 'services/param-utils';
import { buildCreativeSizes } from 'services/utils';
import config from 'config';
import Sidebar from 'components/molecules/Sidebar/Sidebar';
import ContentFrame from 'components/molecules/ContentFrame';
import MetaTags from 'components/atoms/MetaTags';

import './AppShareLayout.scss';

const { Content } = Layout;

const AppShareLayout = () =>{  
  const { screenSizeClass, creative, playerSizeFormat } = useAppState();
  const dispatch = useAppDispatch();

  const [url, setUrl] = useState<string>('');
  const [useSizeSelected, setUseSizeSelected] = useState(true);

  const { encoded_params: encodedParams = '' } = useParams();

  const { result, loading, error }: UseRequestType = useRequest(url);

  useEffect(() => {
    const validatedParams = readParams(encodedParams, 'share');
    const { error: validationErr, success: validationSuccess } = validatedParams;
    if (validationErr) {
      const msg = 'There was an error finding the requested creative. Please check the url or contact support.';
      dispatch(setError({ status: 403, message: msg }));
      message.error(msg, 5); // 2nd param is duration in seconds
    }
    if (validationSuccess) {
      const [ paramGroup ] = validationSuccess;
      const creativeParams: ShareUrlParamsType = getParamsObj(paramGroup);
      const id: string = paramGroup[0];
      setUrl(`${config.api.root}/creatives/${id}/player?cb=${Date.now().toString()}`);
      if(creativeParams.playerSizeFormat === '-1') {
        setUseSizeSelected(false)
      }
      dispatch(setParams(creativeParams));
}
  }, []);

  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(setError(error));
    }
  }, [error]);

  useEffect(() => {
    if (result.data) {
      dispatch(setInitialData(result.data));
    }
  }, [result.data]);

  useEffect(() => {
    if(creative?.id && !isMobileOnly) { // mobile view won't need a dropdown
      const dropdown =  buildCreativeSizes(creative)
      dispatch(setSizeChangerList(dropdown)); // save size options
      if(useSizeSelected) {
        dispatch(setCreativeViewSize({...dropdown[parseInt(playerSizeFormat, 10)].size, share: true})) // default size
      }
    } else { // most mobile views will be 100% except for banners, so modify in lower components
      dispatch(setCreativeViewSize({width: '100%', height: '100%', share: true}))
    } 
  }, [creative?.id, playerSizeFormat]);

  return (
    <div className={`app-container ${screenSizeClass}`}>
      {creative?.id && <MetaTags creative={creative} view='share' />}
      <Layout>
        <Sidebar />
        <Layout className='app-container__main'>
          {/* <Header className={`app-container__main__header ${isLandscape ? 'landscape' : ''} ${isMobileOnly ? 'mobile' : ''}`}>
            <AppHeader />
          </Header> */}
          <Content className='app-container__main__body'>
            <ContentFrame/>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default AppShareLayout;
